import { render, staticRenderFns } from "./VerTicketView.vue?vue&type=template&id=133b1c22&"
import script from "./VerTicketView.vue?vue&type=script&lang=js&"
export * from "./VerTicketView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports